import { Button, Input, Typography } from '@breetometer/components';
import { useModalApi } from 'BreetHooks';

import type { IRecoveryCodeFormProps } from './RecoveryCodeForm.helpers';

const RecoveryCodeForm = ({
	errorMessage,
	handleRecoveryCodeValue,
	submitRecoveryCode,
	btnDisabled,
	isLoading,
	recoveryCodeValue,
	userPreferenceData,
}: IRecoveryCodeFormProps) => {
	const { handleOpenModal } = useModalApi();

	const usedRecoveryCodesCount = userPreferenceData?.data?.usedRecoveryCodesCount ?? 0;
	const unUsedRecoveryCodesCount = userPreferenceData?.data?.unusedRecoveryCodesCount ?? 0;

	const isRecoveryCodeCount = usedRecoveryCodesCount >= 7 && usedRecoveryCodesCount <= 10;

	return (
		<div className='new-recovery-code'>
			<Typography
				as='h5'
				className='color-neutral-50'
			>
				Enter Recovery Code
			</Typography>

			<Typography className='color-primary-100'>Enter one of your single-use recovery codes to verify your identity.</Typography>

			<Input
				label='Recovery Code'
				id='recovery-code'
				widthType='full'
				onChange={handleRecoveryCodeValue}
				errorMessage={errorMessage}
				value={recoveryCodeValue}
				required
			/>

			{isRecoveryCodeCount && (
				<div className='recovery-codes-count'>
					<Typography>
						{unUsedRecoveryCodesCount} Recovery Code{unUsedRecoveryCodesCount === 1 ? '' : 's'} left
					</Typography>
				</div>
			)}

			<Button
				variant='primary'
				onClick={submitRecoveryCode}
				isLoading={isLoading}
				disabled={btnDisabled}
				type='button'
			>
				Continue
			</Button>

			<div className='support-alternative'>
				<Typography className='color-primary-100'>Having troubles using recovery code?</Typography>
				<Button
					variant='native'
					className='color-tertiary-400'
					onClick={handleOpenModal({ id: 'contactSupport' })}
					type='button'
				>
					Contact Support
				</Button>
			</div>
		</div>
	);
};

export default RecoveryCodeForm;
